// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../engines/gameEngine";
import utilsView from "../../../../engines/libs/utilsView";
import { MessageEventKind } from "../../../define/MessageEventKind";
import { UIKind } from "../../../define/UIKind";
import { BUNDLE_SMALL_NAME } from "../../BundleResourceConfig";
import NormalGameManager from "../../manager/NormalGameManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class SkipPlotSelectLayer extends BasePopUpLayer {

   

    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        O1HD.getModules().uiControlModule.hideLoading();

    }

    protected onDestroy(): void {
        O1HD?.emit("normalMode.onBackNormal", UIKind.UILayerTag.SkipPlotSelectLayer);
    }

    onClickSelect1() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.finishSkip();
    }

    onClickSelect2() {
        O1HD.getManagers().soundMgr.playSound("anNiu");

        utilsView.openPopupLayer(
            'prefab/SkipPlotConfirmLayer'
            , BUNDLE_SMALL_NAME.skipPlotBundle
            , this.node
            , {
                parent: this
            }
        );
    }

    finishSkip() {
        NormalGameManager._instance.setGameData({bSkipPlot: true});
        O1HD.emit(MessageEventKind.EventName.REFRESH_SPECIAL_BTN_STATE);
        this.destroyNode();
    }


    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.destroyNode();
    }

    // update (dt) {}
}
